import script from "./SkyscannerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SkyscannerComponent.vue?vue&type=script&setup=true&lang=js"

import "./SkyscannerComponent.vue?vue&type=style&index=0&id=67210263&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67210263"]])

export default __exports__